<template>
    <div class="page-wrapper">
        <navbar></navbar>
        <div class="page-content">
            <div class="row">
                <div class="col-md-12 grid-margin stretch-card">
                    <div class="card">
                        <div class="card-body">
                            <div class="d-flex justify-content-between">
                                <h6 class="card-title">Year Period</h6>
                                <router-link :to="{name: 'year_period_add'}" class="btn btn-primary">Add Data</router-link>
                            </div>
                            <div class="d-flex">
                                <p class="card-description mr-auto p-2">Set the year of the study period</p>
                                <div class="p-2">
                                   <input type="text" class="form-control w-100" placeholder="search here" v-model="keywords" v-on:keyup.enter="getData()">
                                </div>
                            </div>
                            <div class="table-responsive" v-if="!dataFetch">
                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th class="text-center" width="3%">#</th>
                                            <th>Code</th>
                                            <th>Name</th>
                                            <th>Status</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody v-if="dataList.length > 0">
                                        <tr v-for="(item, index) in dataList" :key="index">
                                            <td class="text-center" width="3%">
                                                {{ (index + 1) + (pagination.currentPage - 1) * pagination.limit }}
                                            </td>
                                            <td>{{item.code}}</td>
                                            <td>{{item.name}}</td>
                                            <td>
                                                <label class="badge badge-success" v-if="item.active == 1">Active</label>
                                                <label class="badge badge-warning" v-if="item.active != 1">Non Active</label>
                                            </td>
                                            <td>
                                                <router-link :to="{name: 'year_period_edit', params: {id:item.id}}" class="btn btn-outline-primary">Edit</router-link>
                                                <button class="btn btn-danger ml-2" v-on:click="deleteData(item.id)">Delete</button>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tbody v-if="dataList.length == 0">
                                        <tr>
                                            <td colspan=5>
                                                <div class="d-block p-3 rounded bg-light">
                                                    <div class="text-center">Data not found</div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="d-block p-3 rounded bg-light" v-if="dataFetch">
                                <div class="text-center">loading data...</div>
                            </div>
                            <div class="d-block mt-3">
                                <v-pagination v-model="pagination.currentPage" :page-count="pagination.totalPages" :classes="pagination.bootstrapPaginationClasses" :labels="pagination.paginationAnchorTexts" v-on:change="getData()"></v-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <foot></foot>
    </div>
</template>

<script>
    import vPagination from 'vue-plain-pagination'
    
    export default {
        name: 'YearPeriod',
        metaInfo: {
            title: 'Year Period',
            titleTemplate: '%s - Elearning'
        },
        components: {
            vPagination,
        },
        data() {
            return {
                dataFetch: true,
                dataList: [],
                keywords: "",
                pagination: {
                    currentPage : 1,
                    totalPages  : 1,
                    limit       : 10,
                    bootstrapPaginationClasses: {
                        ul: 'pagination justify-content-end',
                        li: 'page-item',
                        liActive: 'active',
                        liDisable: 'disabled',
                        button: 'page-link'
                    },
                    paginationAnchorTexts: {
                        first: 'First',
                        prev: 'Previous',
                        next: 'Next',
                        last: 'Last'
                    }
                },
            }
        },
        created() {
            this.getData();
        },
        methods: {
            getData: function() {
                let uri         = process.env.VUE_APP_APIHOST+'admin/periode/list';

                this.dataFetch  = true;                
                this.$http.get(uri,{
                    params : {
                        keywords : this.keywords,
                        page     : this.pagination.currentPage,
                        limit    : this.pagination.limit
                    }
                }).then(res => {
                    this.dataFetch              = false;
                    this.dataList               = res.data.data;
                    this.pagination.totalPages  = res.data.total_page;
                });
            },
            deleteData: function (id) {
                this.$swal({
                    icon: 'info',
                    title: 'Delete Data',
                    text: 'Are you sure you want to delete this data?',
                    showCancelButton: true,
                    confirmButtonText: 'Delete',
                    cancelButtonText: 'Cancel',
                }).then((result) => {
                if (result.value) {
                    this.$http.post(process.env.VUE_APP_APIHOST + 'admin/periode/delete', {
                        id: id
                    })
                    .then(response => {
                        if (response.data.status) {
                            this.$swal({
                                icon: 'success',
                                title: 'Success',
                                text: response.data.message,
                                confirmButtonText: 'OK'
                            }).then((result) => {
                                if (result.value) {
                                    this.getData();
                                }
                            });
                        } else {
                        this.$swal({
                            icon: 'warning',
                            title: 'Ups!',
                            text: response.data.message,
                        });
                        }
                    })
                }
                });
            },
        }
    }
</script>